import Typography from 'components/shared/Typography/Typography';

import TableCell from './TableCell';

const TableFooter = ({ columnDefs, rowData }) => {
  const lastIdx = columnDefs.length - 1;

  const totals = columnDefs.map((columnDefinition) => {
    if (columnDefinition.aggFunc === 'sum') {
      let columnSum = 0;
      for (let rowIndex = 0; rowIndex < rowData.length; rowIndex++) {
        let cellValue = rowData[rowIndex][columnDefinition.field];
        if (typeof cellValue !== 'number' || isNaN(cellValue)) {
          cellValue = 0;
        }
        columnSum += cellValue;
      }
      if (columnDefinition.valueFormatter) {
        return columnDefinition.valueFormatter({
          value: columnSum,
          data: null,
          rowIdx: null,
          colDef: columnDefinition
        });
      }
      return columnSum;
    }
    return '';
  });

  return (
    <tr className="border-0 border-t border-solid border-neutral-300">
      {columnDefs.map((col, index) => (
        <TableCell
          key={String(col.field)}
          index={index}
          lastIdx={lastIdx}
          className="px-0"
          style={{
            width: col.width || `${100 / columnDefs.length}%`
          }}>
          <Typography variant="label" size="medium" weight="medium" className="whitespace-nowrap">
            {index === 0 ? 'Total' : totals[index] !== null ? totals[index] : ''}
          </Typography>
        </TableCell>
      ))}
    </tr>
  );
};

export default TableFooter;
